import { render, staticRenderFns } from "./ModelPersonDiseaseNotes.vue?vue&type=template&id=ef4f08d8&scoped=true"
import script from "./ModelPersonDiseaseNotes.vue?vue&type=script&lang=js"
export * from "./ModelPersonDiseaseNotes.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ef4f08d8",
  null
  
)

export default component.exports